import React from 'react';
import { BookContent } from '../type';
import { useBookState } from './Book.state';
import { BookView } from './Book.view';

interface BookProps {
    onBookSelect: (content: BookContent) => void;
}

const Book: React.FC<BookProps> = ({ onBookSelect }) => {
    const state = useBookState(onBookSelect);
    return <BookView {...state} searchBooks={state.searchBooks} clearSearchResults={state.clearSearchResults} />;
};

export default Book;
